import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function swiperFullFade() {
    const swipers = document.querySelectorAll('[data-swiper-full-fade]');

    swipers.forEach(container => {
        new Swiper(container, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });
}